/**
 *
 * Created by vsuthar on 10/5/18 File Store
 * Project: App Portal ©PaloAlto Networks
 */

import { createStore, combineReducers, applyMiddleware, compose } from 'redux'
import reducers from './reducers'
import thunk from 'redux-thunk'
const middlewares = [thunk]

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

/**
 *
 * @param preloadedState
 * @param appConfig
 * @returns {Store<any> & {dispatch: any}}
 * @constructor
 */
const Store = (preloadedState, appConfig = {}) => {
  return createStore(
    combineReducers({
      ...reducers,
      ...appConfig.reducers
    }),
    preloadedState,
    composeEnhancers(
      applyMiddleware(...middlewares)
    )
  )
}


export default Store
